'use client';

import { useMemo } from 'react';

import { cn } from '@kit/ui/utils';

import { FeaturesList } from '~/components/features-list';
import type { ExtractionStats } from '~/lib/feature-items';
import { buildFeatureItems } from '~/lib/feature-items';

interface HomeFeaturesCarouselProps {
  extractionStats: ExtractionStats;
  className?: string;
  lastSyncAt?: string | null;
}

function SectionTitle() {
  return (
    <div className="mb-5 flex items-center justify-center sm:mb-6">
      <div className="inline-flex items-center gap-2.5">
        <span
          aria-hidden="true"
          className="h-px w-10 bg-slate-300 dark:bg-slate-600"
        />
        <h2 className="font-heading relative -skew-x-3 px-2 py-0.5 text-sm font-semibold tracking-[0.08em] text-slate-700 uppercase italic sm:text-base dark:text-slate-200">
          <span
            aria-hidden="true"
            className="absolute right-0 bottom-0 left-0 h-[0.8em] -skew-x-3 rounded-[2px] bg-green-300/70 dark:bg-green-500/25"
          />
          <span className="relative z-10">Jak działamy?</span>
        </h2>
        <span
          aria-hidden="true"
          className="h-px w-10 bg-slate-300 dark:bg-slate-600"
        />
      </div>
    </div>
  );
}

export function HomeFeaturesCarousel({
  extractionStats,
  className,
  lastSyncAt,
}: HomeFeaturesCarouselProps) {
  const featureItems = useMemo(
    () => buildFeatureItems(extractionStats, lastSyncAt),
    [extractionStats, lastSyncAt],
  );

  return (
    <section
      aria-label="Jak działamy?"
      className={cn(
        'mt-auto mb-6 w-full bg-[#f7f5ef]/60 px-4 py-5 max-sm:mt-8 dark:bg-stone-900/50',
        className,
      )}
    >
      <SectionTitle />

      <div className="mx-auto max-w-2xl">
        <FeaturesList items={featureItems} />
      </div>
    </section>
  );
}
